import type { EditorThemeClasses } from "lexical";
import { CONTENT_CLASSES } from "../core/content-classes";

export const EDITOR_THEME: EditorThemeClasses = {
  paragraph: CONTENT_CLASSES.paragraph,
  quote: CONTENT_CLASSES.quote,
  heading: {
    h1: CONTENT_CLASSES.h1,
    h2: CONTENT_CLASSES.h2,
    h3: CONTENT_CLASSES.h3,
    h4: CONTENT_CLASSES.h4,
    h5: CONTENT_CLASSES.h5,
    h6: CONTENT_CLASSES.h6,
  },
  list: {
    ul: CONTENT_CLASSES.ul,
    ol: CONTENT_CLASSES.ol,
    checklist: CONTENT_CLASSES.checklist,
    listitem: CONTENT_CLASSES.listItem,
    listitemChecked: CONTENT_CLASSES.listItemChecked,
    listitemUnchecked: CONTENT_CLASSES.listItemUnchecked,
    nested: { listitem: CONTENT_CLASSES.nestedListItem },
  },
  link: CONTENT_CLASSES.link,
  hashtag: CONTENT_CLASSES.hashtag,
  code: CONTENT_CLASSES.codeBlock,
  hr: CONTENT_CLASSES.hr,
  // Plain strings, so they cost nothing in an editor that never loads table support.
  table: CONTENT_CLASSES.table,
  tableRow: CONTENT_CLASSES.tableRow,
  tableCell: CONTENT_CLASSES.tableCell,
  tableCellHeader: CONTENT_CLASSES.tableCellHeader,
  tableScrollableWrapper: CONTENT_CLASSES.tableScroll,
  // Editing only: set on the table while cells are selected, and on each selected cell.
  tableSelection: "ze-table-selecting",
  tableCellSelected: "ze-td-selected",
  text: {
    bold: CONTENT_CLASSES.bold,
    italic: CONTENT_CLASSES.italic,
    strikethrough: CONTENT_CLASSES.strikethrough,
    underline: CONTENT_CLASSES.underline,
    underlineStrikethrough: CONTENT_CLASSES.underlineStrikethrough,
    code: CONTENT_CLASSES.code,
    highlight: CONTENT_CLASSES.highlight,
    subscript: CONTENT_CLASSES.subscript,
    superscript: CONTENT_CLASSES.superscript,
  },
};
